export function toGermanDate(date) {
    let datum = new Date(date);
    let tag = String(datum.getDate()).padStart(2, '0');
    let monat = String(datum.getMonth() + 1).padStart(2, '0'); // Monate von 0-11
    let jahr = datum.getFullYear();

    return `${tag}.${monat}.${jahr}`;
}